"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classification_1 = require("./classification");
exports.KNeighborsClassifier = classification_1.KNeighborsClassifier;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL25laWdoYm9ycy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLG1EQUF3RDtBQUUvQywrQkFGQSxxQ0FBb0IsQ0FFQSJ9